import { useState } from "react";
import { DataSourcesPage } from "./DataSourcesPage";
import { WhatsappInstancesPage } from "./WhatsappInstancesPage";
import { UsersPage } from "./UsersPage";
import { PageHeader } from "../components/PageHeader";
import { IconDatabase, IconWhatsApp, IconUser, IconCog } from "../components/icons";

type Tab = "datasources" | "whatsapp" | "users" | "general";

export function SettingsPage() {
  const [tab, setTab] = useState<Tab>("datasources");

  const TABS = [
    { id: "datasources" as Tab, label: "Bancos de Dados", icon: IconDatabase },
    { id: "whatsapp"    as Tab, label: "WhatsApp",         icon: IconWhatsApp },
    { id: "users"       as Tab, label: "Usuários",         icon: IconUser     },
    { id: "general"     as Tab, label: "Geral",            icon: IconCog      },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Configurações"
        subtitle="Bancos de dados, WhatsApp, usuários e preferências do sistema"
      />

      {/* Tab bar */}
      <div className="flex gap-1 bg-surface-muted p-1 rounded-xl border border-surface-border">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors flex-1 justify-center ${
              tab === t.id ? "bg-white text-gray-900 shadow-card" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <t.icon className="w-4 h-4" />
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div>
        {tab === "datasources" && <DataSourcesPage />}
        {tab === "whatsapp"    && <WhatsappInstancesPage />}
        {tab === "users"       && <UsersPage />}
        {tab === "general"     && (
          <div className="space-y-4">
            <div className="card p-5">
              <p className="text-sm font-semibold text-gray-900 mb-4">Preferências gerais</p>
              <div className="space-y-4">
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Fuso horário</label>
                  <select className="w-full max-w-xs text-sm border border-surface-border rounded-lg px-3 py-2">
                    <option>America/Manaus (UTC-4)</option>
                    <option>America/Sao_Paulo (UTC-3)</option>
                    <option>America/Belem (UTC-3)</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Período padrão</label>
                  <select className="w-full max-w-xs text-sm border border-surface-border rounded-lg px-3 py-2">
                    <option>Mês atual</option>
                    <option>Últimos 30 dias</option>
                    <option>Trimestre atual</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Provedor de IA</label>
                  <select className="w-full max-w-xs text-sm border border-surface-border rounded-lg px-3 py-2">
                    <option>Stub (desenvolvimento)</option>
                    <option>Claude (Anthropic)</option>
                    <option>GPT-4o-mini (OpenAI)</option>
                    <option>Gemini Flash (Google)</option>
                  </select>
                </div>
                <button className="btn-primary">Salvar preferências</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
